import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Modal, Segment} from 'semantic-ui-react';
import {Actions} from '../../../common/actions';

class SubstituteComposition extends Component {
  constructor(props) {
    super(props);
    this.state = {'isOpen': false};

    this.handleOpen = this.handleOpen.bind(this);
    this.handleClose = this.handleClose.bind(this);
  }
  
  handleOpen() {
    const {order} = this.props;
    this.setState({'isOpen': true});
    this.props.getPartSpecialSubstitutes(order.code);
  }

  handleClose() {
    this.setState({'isOpen': false});
  }

  renderComposition() {
    const {loadingComposition, composition} = this.props;
    
    if (loadingComposition) {
      return (
        <Segment>Consultando Información...</Segment>
      );
    }

    return composition.map((element, index) => {
      return (
        <Segment key={index}>
          {element.code} | Cantidad: {element.quantity}
        </Segment>
      );
    });
  }

  render() {
    const {order} = this.props;

    if (!order.spareParts) {
      return (<span>NO</span>);
    }

    return (
      <Modal closeIcon
        size='small'
        trigger={<a onClick={this.handleOpen}>{order.spareParts}</a>}
        open={this.state.isOpen}
        onClose={this.handleClose}
      >
        <Modal.Header>Despiece</Modal.Header>
        <Modal.Content>
          <Segment.Group>
            {this.renderComposition()}
          </Segment.Group>
        </Modal.Content>
      </Modal>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    'loadingComposition': state.dealerEmergingOrders.loadingComposition,
    'composition': state.dealerEmergingOrders.composition,
  };
};

const {getPartSpecialSubstitutes} = Actions;

export default connect(mapStateToProps, {
  getPartSpecialSubstitutes,
})(SubstituteComposition);
